import {$auth} from "@/plugins/auth"
import type {NavigationGuardNext, RouteLocationNormalized, RouteLocationNormalizedLoaded} from "vue-router"
import routeTo from "@/plugins/route"
import {ROUTES} from "@/router/paths"
import {UserTypes} from "@/enums/UserTypes"

export default class Guest implements App.Middleware.Instance {
  async handle(
    to: RouteLocationNormalized,
    from: RouteLocationNormalizedLoaded,
    next: App.Middleware.Caller,
    cancel: NavigationGuardNext
  ): Promise<void> {
    if ($auth.user) {
      switch ($auth.user.user_type) {
        case UserTypes.BENEFICIARY:
          return cancel(routeTo(ROUTES.BENEFICIARY_FOLDERS))
        case UserTypes.ADMIN:
          return cancel(routeTo(ROUTES.ADMIN_DASHBOARD))
        case UserTypes.USER:
          return cancel(routeTo(ROUTES.DASHBOARD))
        default:
          // If the user type is not recognized, redirect to the login
          return cancel(routeTo(ROUTES.LOGIN))
      }
    }

    await next(to, from, cancel)
  }
}
